<form [formGroup]="muestreadorFormGroup">
  <div class="row">
    <h4>Datos del muestreador</h4>
  </div>
  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput placeholder="Formación/ ocupación:" formControlName="formacion_ocupacion" required>
      <mat-error *ngIf="muestreadorFormGroup.get('formacion_ocupacion')?.hasError('required')">
        Debe ingresar formación/ocupación
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput placeholder="Lugar de trabajo:" formControlName="lugar_trabajo" required>
      <mat-error *ngIf="muestreadorFormGroup.get('lugar_trabajo')?.hasError('required')">
        Debe ingresar lugar de trabajo
      </mat-error>
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput placeholder="Descripción de experiencia:" formControlName="descripcion_experiencia" required>
      <mat-error *ngIf="muestreadorFormGroup.get('descripcion_experiencia')?.hasError('required')">
        Debe ingresar descripción de experiencia
      </mat-error>
    </mat-form-field>
  </div>


  <div class="row">
    <rpe-tecnico-form [formInput]="tecnicoFormInput">
    </rpe-tecnico-form>
  </div>


</form>
